import { hasCapability, type User } from "../base";
import { NON_EXISTENT_ID } from "../utils/types";

export const funding = {
  read: (user: User) => hasCapability(user, "funding.read"),
  create: (user: User) => hasCapability(user, "funding.create"),
  update: (user: User) => hasCapability(user, "funding.update"),
  cancel: (user: User) => hasCapability(user, "funding.cancel"),
};

export const escrowWhere = (user: User) => {
  if (funding.read(user)) {
    return {};
  }
  return { AND: [{ id: NON_EXISTENT_ID }] };
};

export const financingWhere = (user: User) => {
  if (funding.read(user)) {
    return {};
  }
  return { AND: [{ id: NON_EXISTENT_ID }] };
};
